import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { Suspense } from "react";
import { LoadingDots } from "@repo/components/atoms/loading-dots";
import { cn } from "@repo/lib";
import { RefineByItemDropdown } from "#/components/molecules/search-refinements/refine-by-item-dropdown";
export function RefineBy(t0) {
  const $ = _c(16);
  const {
    active,
    children,
    className,
    title
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("uppercase", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title ? <h3 className="hidden md:block">{title}</h3> : null;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LoadingDots />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = <Suspense fallback={t3}><nav className="hidden md:grid">{children}</nav></Suspense>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LoadingDots />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== active || $[9] !== children) {
    t6 = <Suspense fallback={t5}><RefineByItemDropdown active={active} className="md:hidden">{children}</RefineByItemDropdown></Suspense>;
    $[8] = active;
    $[9] = children;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = <><section className={t1}>{t2}{t4}{t6}</section></>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}